import { useNavigate, useParams } from 'react-router-dom';
import FounderDetailCard from '@/components/Cards/FounderDetailCard';
import { Preloader } from '@/components/Preloader';
import { BackButton } from '@/components/UI/Buttons';
import { useGetFounderFundraisingStatus } from '@/query/queries/brand/useGetFounderFundraisingStatus';
import { useGetFounderDetail } from '@/query/queries/brand/useGetFounderDetail';
import './index.scss';

const FounderDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: fundraising } = useGetFounderFundraisingStatus(id);
  const { data: detail, isLoading } = useGetFounderDetail(id);

  const onBack = () => {
    navigate(-1);
  };

  return (
    <div className="founder-detail-page">
      <div className="container-inner">
        <div className="founder-detail-page__back">
          <BackButton onClick={onBack} />
        </div>
        {isLoading ? (
          <Preloader className="founder-detail-page__preloader" />
        ) : (
          <FounderDetailCard founder={detail} fundraising={fundraising} />
        )}
      </div>
    </div>
  );
};

export default FounderDetailPage;
